import {
  USER_LOGIN_LOADING,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_ERROR,
  GET_DASHBOARD_PLAYER_DETAILS_LOADING,
  GET_DASHBOARD_PLAYER_DETAILS_SUCCESS,
  GET_DASHBOARD_PLAYER_DETAILS_ERROR,
  USER_ROLE,
} from "../../../constant/actionTypes";
import axios from "axios";
import { BASE_URL } from "../../../constant/apiURL";
import { apiPost, apiGet } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { toast } from "react-toastify";

export const userLogin = (data, navigate) => (dispatch) => {
  dispatch({ type: USER_LOGIN_LOADING });
  apiPost(
    ApiEndpoints.login,
    data,
    (response) => {
      if (response.error) {
        toast.error(response.message);
        dispatch({ type: USER_LOGIN_ERROR });
      } else {
        let token = response.data.token;

        if (data.checked) {
          localStorage.setItem(
            "credentials",
            JSON.stringify(data)
          );
        } else {
          localStorage.removeItem("credentials");
        }

        localStorage.setItem("token", token);

        dispatch({ type: USER_LOGIN_SUCCESS, response: response });
        navigate("/");
      }
    },
    (error) => {
      toast.error(error.message);
      dispatch({ type: USER_LOGIN_ERROR });
    }
  );
};

export const getUserDetails = () => (dispatch) => {
  dispatch({ type: GET_DASHBOARD_PLAYER_DETAILS_LOADING });
  apiGet(
    "/api/user/basic-info",
    (response) => {
      // console.log("get user details response ==============> ", response);
      if (response.error == true) {
        dispatch({
          type: GET_DASHBOARD_PLAYER_DETAILS_ERROR,
          response: response.message,
        });
      } else {
        dispatch({
          type: GET_DASHBOARD_PLAYER_DETAILS_SUCCESS,
          response: response,
        });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: GET_DASHBOARD_PLAYER_DETAILS_ERROR, response: error });
    }
  );
};

export const getUserRole = (user) => (dispatch) => {
  if (user.user_role.length > 0) {
    let checkSuperAdmin = user.user_role.filter((val) =>
      val.toString().toLowerCase().includes("super_admin")
    );

    if (checkSuperAdmin.length > 0) {
      dispatch({
        type: USER_ROLE,
        response: "super",
      });
    } else {
      let filterRole = user.user_role.filter((val) =>
        val.toString().toLowerCase().includes("admin")
      );

      if (filterRole.length > 0) {
        dispatch({
          type: USER_ROLE,
          response: "admin",
        });
      } else {
        dispatch({
          type: USER_ROLE,
          response: "player",
        });
      }
    }
  }
};
